<template>
  <BaseSection
    heading="Pensioneringsavtal och TGL"
    :infoStatus="avtal.infoStatus"
    :show-error="!!avtal.error"
  >
    <div class="spinner-wrapper" v-if="avtal.isLoading"><SmallSpinner /></div>
    <avtalat-table
      v-if="!avtal.isLoading"
      :headings="headings"
      :striped="false"
    >
      <avtalat-table-row
        v-for="(forsakringsavtal, index) in avtal.data?.forsakringsavtal"
        :key="index"
      >
        <avtalat-table-cell>{{
          forsakringsavtal.avtalstypNamn
        }}</avtalat-table-cell>
        <avtalat-table-cell>{{
          forsakringsavtal.tecknatGenom
        }}</avtalat-table-cell>
        <avtalat-table-cell>{{ forsakringsavtal.giltigFrom }}</avtalat-table-cell>
        <avtalat-table-cell>{{ forsakringsavtal.giltigTom || "Tillsvidare" }}</avtalat-table-cell>
      </avtalat-table-row>
    </avtalat-table>
  </BaseSection>
</template>

<script setup lang="ts">
import { computed } from "vue";

import SmallSpinner from "@/components/ui/SmallSpinner.vue";
import { BaseSection } from "@/components/sections";

import { useArbetsgivareStore } from "../store";

const arbetsgivareStore = useArbetsgivareStore();
const avtal = computed(() => arbetsgivareStore.avtal);

const headings = [
  {
    content: "Avtal",
  },
  {
    content: "Tecknat genom",
  },
  {
    content: "Gäller från",
  },
  {
    content: "Gäller till",
  },
];
</script>

<style scoped>
.spinner-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
</style>
